/* eslint react/prop-types: 0 */
import { useRef, useEffect } from "react"
import "./hyrisShape"
import mojs from "@mojs/core"
import { Box } from "@mui/material"

const MojsExample = ({ duration }) => {
  const animDom = useRef()
  const logo = useRef()

  useEffect(() => {
    // Prevent multiple instantiations on hot reloads
    if (logo.current) return

    // Assign a Shape animation to a ref
    logo.current = new mojs.Shape({
      parent: animDom.current,
      shape: "hyris",
      scale: { 1: 2 },
      rotate: { 0: 360 },
      fill: "none",
      repeat: 999,
      stroke: { "#00fefc": "#fff700" },
      strokeDasharray: "100%",
      strokeWidth: 1,
      strokeDashoffset: { "-100%": "200%" },
      duration: duration,
      isShowStart: true,
      isShowEnd: false,
      isYoyo: true,
      easing: "ease.inout",
    }).play()
  })

  return (
    <Box
      ref={animDom}
      className="Loader"
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
  )
}

export default MojsExample
